import React from "react";
import { Box, styled } from "@mui/material";
import { Outlet } from "react-router-dom";
import AppSidebar from "./app-sidebar";
import Navbar from "./navbar";

const LayoutRoot = styled(Box)(() => ({
  maxWidth: "100%",
  margin: "0 auto",
}));

const LayoutWrapper = styled(Box)(() => ({
  minHeight: "100vh",
  display: "flex",
}));

const SidebarWrapper = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("lg")]: {
    display: "none",
  },
}));

const MainWrapper = styled(Box)(() => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  minWidth: 0,
}));

const ContentWrapper = styled(Box)(() => ({
  width: "100%",
  flex: 1,
}));

const DashboardLayout = () => {
  return (
    <LayoutRoot>
      <LayoutWrapper>
        <SidebarWrapper>
          <AppSidebar />
        </SidebarWrapper>

        <MainWrapper>
          <Navbar />

          <ContentWrapper>
            <Outlet />
          </ContentWrapper>
        </MainWrapper>
      </LayoutWrapper>
    </LayoutRoot>
  );
};

export default DashboardLayout;
